<template>
  <div>
    <div v-if="loading" class="C-PageLoading">
      <div class="Spinner spinner-grow text-primary"></div>
    </div>
    <div v-if="!loading">
      <ad></ad>
      <HotCity></HotCity>
      <div class="G-Title">
        <label>
          <svg-icon icon-class="hot"></svg-icon>
          热门：</label>
        <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          {{dropdown_title}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="dropdown_id === 0" command='0'>当下热门</el-dropdown-item>
            <el-dropdown-item :disabled="dropdown_id === 1" command='1'>一周热门</el-dropdown-item>
            <el-dropdown-item :disabled="dropdown_id === 2" command='2'>本月热门</el-dropdown-item>
            <el-dropdown-item :disabled="dropdown_id === 3" command='3'>上月热门</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <information ref="son" :data="data" :page="false" :fullscreenLoading="fullscreenLoading"></information>
    </div>
  </div>
</template>
<script>
import HotCity from './widget/hotcity'
import ad from './widget/ad'
import information from './widget/information'
import {request} from '../network/request'
import cookies from 'js-cookie'
export default {
  name: 'HelloWorld',
  components: {
    HotCity,
    ad,
    information
  },
  watch: {
    $route: {
      handler: function () {
        if (this.$route.query.u) {
          cookies.set('u', this.$route.query.u)
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      dropdown_title: '当下热门',
      dropdown_id: 0,
      data: {},
      loading: true,
      announcement: '',
      info_ad: '',
      fullscreenLoading: false
    }
  },
  methods: {
    handleCommand (command) {
      this.fullscreenLoading = true
      if (command === '0') {
        this.dropdown_title = '当下热门'
        this.dropdown_id = 0
      } else if (command === '1') {
        this.dropdown_title = '一周热门'
        this.dropdown_id = 1
      } else if (command === '2') {
        this.dropdown_title = '本月热门'
        this.dropdown_id = 2
      } else {
        this.dropdown_title = '上月热门'
        this.dropdown_id = 3
      }
      // this.$message('click on item ' + command)
      this.info(command)
    },
    info (command) {
      let data = new URLSearchParams()
      data.append('sort', command)
      data.append('cid', 'all')
      data.append('page', '1')
      request({
        url: '/api/lists',
        method: 'post',
        data: data
      }).then(res => {
        this.data = res.data.data
        if (this.data.length >= 6) {
          for (let item of this.info_ad) {
            let random = Math.round(Math.random() * (res.data.data.length - 1))
            this.data.splice(random, 1, item)
          }
        }
        this.loading = false
        this.fullscreenLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    ad () {
      this.icon_ad = JSON.parse(localStorage.getItem('ad')).icon
      this.info_ad = JSON.parse(localStorage.getItem('ad')).info
    },
    open () {
      request({
        url: '/api/tip',
        method: 'post'
      }).then(res => {
        this.alert = res.data.alert
        if (!cookies.get('notice')) {
          this.$msgbox(this.alert, '温馨提示', {
            confirmButtonText: '确定',
            lockScroll: false
          })
          cookies.set('notice', 'true', {expires: 1})
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.open()
    this.info(0)
    this.ad()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-dropdown-link {
    cursor: pointer;
    color: black;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .svg-icon {
    margin-right: 3px;
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue